import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Subject } from 'rxjs';
import { ResponseModel } from '@shared/models/response.model';
import { MenuItemModel } from '@shared/models/menu-item.model';
import { getCurrentContextIds } from '@shared/utils/current-context.util';

@Injectable({ providedIn: 'root' })
export class NewMenuItemService {
  private update = new Subject<string>();
  constructor(private http: HttpClient) {}

  getAll(
    menuId = '',
    categoryId = '',
    page = 0,
    perPage = 5,
    sort: string | null = null,
    filterKeyword: string | null = null,
    filterStatus: string | null = null,
    role: string | null = null
  ) {
    let params = new HttpParams().set('page', page).set('per_page', perPage);
    if (sort !== null) {
      params = params.set('sort', sort);
    }
    if (role !== null) {
      params = params.set('filter[role]', role);
    }

    if (filterKeyword !== null) {
      params = params.set('filter[search]', filterKeyword);
    }
    if (filterStatus !== null) {
      params = params.set('filter[status]', filterStatus);
    }
    const { restaurantId, branchId } = getCurrentContextIds();
    return this.http.get<ResponseModel<MenuItemModel[]>>(
      `restaurants/${restaurantId}/branches/${branchId}/menus/${menuId}/menu-categories/${categoryId}/menu-items`,
      { params }
    );
  }

  addMenuItem(menuId: string, categoryId: string, menuItem: object) {
    const { restaurantId, branchId } = getCurrentContextIds();
    return this.http.post<ResponseModel<MenuItemModel>>(
      `restaurants/${restaurantId}/branches/${branchId}/menus/${menuId}/menu-categories/${categoryId}/menu-items`,
      menuItem
    );
  }

  getMenuItemByID(menuId: string, categoryId: string, id: string, filterStatus: string | null = null) {
    let params = new HttpParams();
    if (filterStatus !== null) {
      params = params.set('filter[status]', filterStatus);
    }
    const { restaurantId, branchId } = getCurrentContextIds();
    return this.http.get<ResponseModel<MenuItemModel>>(
      `restaurants/${restaurantId}/branches/${branchId}/menus/${menuId}/menu-categories/${categoryId}/menu-items/${id}`,{ params }
    );
  }

  editMenuItem(menuId: string, categoryId: string, id: string, menuItem: object) {
    const { restaurantId, branchId } = getCurrentContextIds();
    return this.http.post<ResponseModel<MenuItemModel>>(
      `restaurants/${restaurantId}/branches/${branchId}/menus/${menuId}/menu-categories/${categoryId}/menu-items/${id}?_method=PUT`,
      menuItem
    );
  }

  deleteMenuItem(menuId: string, categoryId: string, id: string) {
    const { restaurantId, branchId } = getCurrentContextIds();
    return this.http.delete(
      `restaurants/${restaurantId}/branches/${branchId}/menus/${menuId}/menu-categories/${categoryId}/menu-items/${id}`
    );
  }

  sendUpdate(message: string) {
    this.update.next(message);
  }

  getUpdate() {
    return this.update.asObservable();
  }
}
